import { ICategory, IPost, ITag, IMeta, IAuthor } from './types';
import getConfig from 'next/config';

interface IProps {
  url: string;
  post?: IPost;
  category?: ICategory;
  tag?: ITag;
  author?: IAuthor;
}

export const getMeta = ({ url, post, category, tag, author }: IProps) => {
  const { APP_ENV } = getConfig().publicRuntimeConfig;
  const meta: IMeta = {
    name: 'Lifepal Media',
    description:
      'Mengelola keuangan dengan maksimal adalah langkah utama mewujudkan semua impian hidup. Dapatkan tip, cara dan informasi keuangan di Lifepal!',
    follow: APP_ENV !== 'production' ? 'nofollow' : 'follow',
    index: APP_ENV !== 'production' ? 'noindex' : 'index',
    url: `${url}`,
    image: 'https://blog-media.lifepal.co.id/app/uploads/sites/3/2020/01/17141437/lifepal-logo.png',
    authorName: 'Lifepal',
    openGraph: {
      locale: 'id_ID',
      type: 'website',
      title: 'Lifepal Media - Tips dan Cara Mengatur Keuangan',
      description:
        'Berbagai artikel, informasi, dan berita untuk membantumu mengatur keuangan dengan maksimal.',
      imageWidth: 1148,
      imageHeight: 1150,
      modifiedTime: '',
      publishedTime: '',
    },
    twitter: {
      card: 'summary_large_image',
      site: '@lifepal',
      title: 'Lifepal Media - Tips dan Cara Mengatur Keuangan',
      description:
        'Berbagai artikel, informasi, dan berita untuk membantumu mengatur keuangan dengan maksimal.',
    },
  };

  if (post && post.seo) {
    meta.description = post.seo.metaDesc || post.excerpt;
    if (post.featuredImage && post.featuredImage.node && post.featuredImage.node.sourceUrl) {
      meta.image = post.featuredImage.node.sourceUrl;
    }
    meta.openGraph.title = post.seo.opengraphTitle || post.title;
    meta.openGraph.description = post.seo.metaDesc || post.excerpt;
    meta.openGraph.type = post.seo.opengraphType;
    meta.openGraph.modifiedTime = post.seo.opengraphModifiedTime;
    meta.openGraph.publishedTime = post.seo.opengraphPublishedTime;
    meta.twitter.title = post.seo.twitterTitle || post.seo.title;
    meta.twitter.description = post.seo.twitterDescription || post.seo.metaDesc || post.excerpt;
    meta.schema = post.seo.schema.raw;
  } else if (category) {
    meta.description =
      category.seo && category.seo.metaDesc ? category.seo.metaDesc : category.description;
    meta.openGraph.title =
      category.seo && category.seo.opengraphTitle ? category.seo.opengraphTitle : category.name;
    meta.openGraph.description =
      category.seo && category.seo.metaDesc ? category.seo.metaDesc : category.description;
    meta.openGraph.type =
      category.seo && category.seo.opengraphType ? category.seo.opengraphType : '';
    meta.twitter.title =
      category.seo && category.seo.twitterTitle ? category.seo.twitterTitle : category.name;
    meta.twitter.description =
      category.seo && category.seo.twitterDescription
        ? category.seo.twitterDescription
        : category.description;
    meta.schema =
      category.seo && category.seo.schema && category.seo.schema.raw ? category.seo.schema.raw : '';
  } else if (tag && tag.seo) {
    meta.description = tag.seo && tag.seo.metaDesc ? tag.seo.metaDesc : tag.description;
    meta.openGraph.title = tag.seo && tag.seo.opengraphTitle ? tag.seo.opengraphTitle : tag.name;
    meta.openGraph.description = tag.seo && tag.seo.metaDesc ? tag.seo.metaDesc : tag.description;
    meta.openGraph.type = tag.seo && tag.seo.opengraphType ? tag.seo.opengraphType : '';
    meta.twitter.title = tag.seo && tag.seo.twitterTitle ? tag.seo.twitterTitle : tag.name;
    meta.twitter.description =
      tag.seo && tag.seo.twitterDescription ? tag.seo.twitterDescription : tag.description;
    meta.schema = tag.seo && tag.seo.schema && tag.seo.schema.raw ? tag.seo.schema.raw : '';
  } else if (author && author.seo) {
    meta.description = author.seo && author.seo.metaDesc ? author.seo.metaDesc : author.description;
    meta.openGraph.title = author.seo && author.seo.title ? author.seo.title : author.name;
    meta.openGraph.description =
      author.seo && author.seo.metaDesc ? author.seo.metaDesc : author.description;
    meta.twitter.title = author.seo && author.seo.title ? author.seo.title : author.name;
    meta.twitter.description =
      author.seo && author.seo.metaDesc ? author.seo.metaDesc : author.description;
    meta.schema =
      author.seo && author.seo.schema && author.seo.schema.raw ? author.seo.schema.raw : '';
  }

  return meta;
};
